import { Routes, Route, Link } from 'react-router-dom'
import { lazy, Suspense, useEffect } from 'react'
import Loading from '@/core/components/globals/loading'

const Login = lazy(() => import('@/pages/auth/Login'))
const Signup = lazy(() => import('@/pages/auth/Signup'))
const ForgotPassword = lazy(() => import('@/pages/auth/ForgotPassword'))
const ResetPassword = lazy(() => import('@/pages/auth/ResetPassword'))
const AuthCallback = lazy(() => import('@/modules/profile/callback'))
const MFAVerify = lazy(() => import('@/pages/auth/MFAVerify'))
const DebugAuth = lazy(() => import('@/pages/auth/DebugAuth'))

export default function AuthLayout() {
  // Forcer le thème light sur les pages d'authentification
  useEffect(() => {
    document.documentElement.classList.add('light-theme');

    return () => {
      const savedTheme = localStorage.getItem('theme-storage');
      if (savedTheme) {
        try {
          const parsed = JSON.parse(savedTheme);
          document.documentElement.classList.toggle('light-theme', parsed.state?.theme === 'light');
        } catch {
          document.documentElement.classList.remove('light-theme');
        }
      } else {
        document.documentElement.classList.remove('light-theme');
      }
    };
  }, []);

  return (
    <div className="pre-signup-layout">
      <div className="pre-signup-layout__left-side">
        <Link to="/auth/login" className="pre-signup-layout__left-side__logo">
          <img alt="logo" width={180} height={50} src="/assets/images/logo.svg" style={{ objectFit: 'contain' }} />
        </Link>
        <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Loading /></div>}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/callback" element={<AuthCallback />} />
            <Route path="/mfa-verify" element={<MFAVerify />} />
            <Route path="/debug" element={<DebugAuth />} />
          </Routes>
      </Suspense>
      </div>
    </div>
  )
}
